export default __webpack_public_path__ + "static/media/BlueTractor.0f471e5a.jpg";